import { Week } from './api/get-calendar-data-for-house';
import { padDatePart } from './helpers/date';

export const staticText = {
	agreeToBookingProcedureFailureMessage: 'Please confirm you have read and understood that this reservation is a request and will not be valid until confirmed.',
	agreeToTermsFailureMessage: 'Terms need to be accepted to proceed with the reservation.',
	arrivalDate: 'Arrival date',
	available: 'Available',
	availableHousesForRent: 'Available houses for rent',
	bookingFailedBecauseItsADuplicate: 'This reservation request has already been made.',
	bookingFailedBecauseOfReservationConflict: 'This reservation conflicts with another reservation.',
	bookingFailedLikelyInputValuesAreWrong: 'Something went wrong, please check your input and try again.',
	dateHasAnOptionErrorMessage: ( week: Week ): string => {
		return `The date ${week.year}-${padDatePart( week.month )}-${padDatePart( week.date ?? week.day_of_month )} has already an option, but you can still request a booking. You'll become next in line. We will keep you informed about availability.`;
	},
	dateIsBookedErrorMessage: ( week: Week ): string => {
		return `The date ${week.year}-${padDatePart( week.month )}-${padDatePart( week.date ?? week.day_of_month )} is booked, please pick another date or a lower number of nights.`;
	},
	dateIsNotAvailableErrorMessage: ( week: Week ): string => {
		return `The date ${week.year}-${padDatePart( week.month )}-${padDatePart( week.date ?? week.day_of_month )} is not available, please pick another date or a lower number of nights.`;
	},
	departureDate: 'Departure date',
	emailCapitalizedRequired: 'E-mail *',
	emailIsRequiredFailureMessage: 'E-mail is required.',
	emailMustBeValidFormatFailureMessage: 'Enter a valid e-mail address.',
	feedbackOrQuestion: 'Feedback for us / questions',
	fetchingPropertiesDateFailureMessage: 'Something went wrong when fetching the properties data, please try again.',
	fullNameRequired: 'Full name *',
	fullNameIsRequiredFailureMessage: 'Your full name is required.',
	hasOption: 'Has option',
	iAgreeToBookingProcedure: 'I understand that this is a booking request, and that my reservation is only valid upon confirmation.',
	iAgreeToThe: 'I agree to the',
	info: 'Info',
	isBooked: 'Is booked',
	loadingCalendarData: 'Loading calendar data',
	makeBookingRequest: 'Make booking request',
	manyPersons: ( numberOfPersons: number ): string => {
		return `${numberOfPersons} persons`;
	},
	numberOfNights: 'Number of nights',
	numberOfNightsNotANumberFailureMessage: 'Number of nights should be a number.',
	numberOfNightsUnknownValueFailureMessage: 'Number of nights can only be 7, 14, 21 or 28.',
	numberOfPersons: 'Number of persons',
	numberOfPersonsHash: '# Persons',
	numberOfPersonsNotANumberFailureMessage: 'Number of persons should be a number.',
	numberOfPersonsUnknownValueFailureMessage: ( max: number ): string => {
		return `Number of persons should be between 1 and ${max}.`;
	},
	onePerson: '1 person',
	personalDetailsForm: 'Personal details form',
	priceCleaningCost: 'Price cleaning costs',
	priceWeek: ( week: Week ): string => {
		return `Price week ${week.date}/${padDatePart( week.month )}`;
	},
	property: 'Property',
	seeSummary: 'See summary',
	select: 'Select',
	selected: 'Selected',
	somethingHasGoneWrong: 'Something has gone wrong',
	somethingWentWrongServerIssue: 'Something went wrong.<br>— We\'re having issues connecting to the server.',
	startOfStayDateHasAnOption: 'This date has already a reservation option, but you can still request a booking. You\'ll become next in line. We will keep you informed about availability.',
	startOfStayDateIsBooked: 'This date is booked, please try another option.',
	startOfStayDateIsNotAvailable: 'This date is not available, please try another option.',
	startOfStayInNotInTheFutureFailureMessage: 'Please provide a date in the future.',
	startOfStayInValidFailureMessage: 'Please provide a valid date.',
	startOfStayInValidFormatFailureMessage: 'A start date is required in format "yyyy-mm-dd".',
	startOfStaySaturdayToSaturdayMessage: 'Reservations run from Saturday to Saturday. We have modified your choice to the nearest Saturday.',
	submittingOptionFailedNetworkMessage: 'Something went wrong when trying to make your booking request, please try again later.',
	submittingOptionNoDateSelectedFailureMessage: 'Please select a date.',
	submittingOptionNoEmailSelectedFailureMessage: 'Please fill in your e-mail.',
	submittingOptionNoHouseSelectedFailureMessage: 'Please select a house.',
	submittingOptionNoNameSelectedFailureMessage: 'Please fill in your full name.',
	submittingOptionNoTelephoneSelectedFailureMessage: 'Please fill in your telephone.',
	telephoneRequired: 'Telephone *',
	telephoneIsRequiredFailureMessage: 'Telephone is required.',
	totalCost: 'Total cost',
	weAreSorryForThisInconvenience: 'We are very sorry for this inconvenience and doing our best to resolve this problem as soon as possible.',
	yourSelection: 'Your Selection',
};
